import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';

//import Navigation from './Navigation';
import LandingPage from './Landing';
import SignUpPage from '../UserAuth/SignUp';
import SignInPage from '../UserAuth/SignIn';
import PasswordForgetPage from '../UserAuth/UserAccount/PasswordForget'
import HomePage from './Home';
import AccountPage from '../UserAuth/UserAccount/Account';
import EventList from '../Events/EventList';
import AddEvent from '../Events/AddEvent';
import Events from '../Events/Events'
import CanidateList from '../Canidates/CanidateList'
import './App.css'
import MobNav from '../Navigation/MobNav/MobNav'
import * as routes from '../../constants/routes';
import Header from './Header'
import Footer from './Footer'
import AppBar from './AppBar'
import AppNotification from '../Notification/AppNotification';
import AdminHome from '../Admin/AdminHome'
import AdminCanidateList from '../Admin/AdminCanidateList'
import AdminCanidateDetails from '../Admin/AdminCanidateDetails'
import AdminEvents from '../Admin/AdminEvents/AdminEvents'
import AdminEventDetails from '../Admin/AdminEvents/AdminEventDetails';
import AdminEventDetailsNoCanidate from '../Admin/AdminEvents/AdminEventDetailsNoCanidate'
import MyMessagingCenter from '../MessagingCenter/MyMessagingCenter'
import AdminConnectedEvents from '../Admin/AdminEvents/AdminConnectedEvents/AdminConnectedEvents'
import AdminConfirmedEvents from '../Admin/AdminEvents/AdminConfirmedEvents/AdminConfirmedEvents'
import CanidateConfirmedList from '../Canidates/CanidateConfirmedList'
import UserManagement from '../Admin/UserMgm/UserMgm'
import UserUnlocked from '../Admin/UserMgm/UserUnlocked'
import UsersOnline from '../Admin/UserMgm/UserOnline'
import AdminAddEvent from '../Admin/AdminEvents/AddEvent/AdminAddEvent'
import initializeApp from '../../appInit/initializeApp'
import Datenschutz from './Datenschutz'
import GetUnlockedUsersOnline from '../Admin/GetUnlockedUsersNotOnline'

//import Playground from '../../Playground/Playground'
//import firebase from 'firebase'
//import MobNav from './MobNav'
// fetch inital User Data from Firebase to Redux store
// <Playground />
const App = (props) => {

  return (
    <Router>
      <div>
        <Header position="fixed"/>
        <AppBar position="fixed"/>
        <MobNav />
      
        <div id='content'>
          <Route exact path={routes.LANDING} component={() => <LandingPage />} />
          <Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />
          <Route exact path={routes.SIGN_IN} component={() => <SignInPage />} />
          <Route exact path={routes.PASSWORD_FORGET} component={() => <PasswordForgetPage />} />
          
          <Route exact path={routes.HOME} component={() => <HomePage />} />
          <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
          <Route exact path={routes.EVENTLIST} component={() => <EventList />} />
          <Route exact path={routes.ADDEVENT} component={() => <AddEvent />} />
          <Route exact path={routes.EVENTS} component={() => <Events />} />
          <Route exact path={routes.CANIDATELIST} component={() => <CanidateList />} />
          <Route exact path={routes.CANIDATE_CONFIRMED_LIST} component={() => <CanidateConfirmedList />} />
          <Route exact path={routes.ADMINHOME} component={() => <AdminHome />} />
          <Route exact path={routes.ADMINCANIDATELIST} component={() => <AdminCanidateList />} />
          <Route exact path={routes.ADMINCANIDATEDETAILS} component={() => <AdminCanidateDetails />} />
          <Route exact path={routes.MY_MESSAGING_CENTER} component={() => <MyMessagingCenter />} />
          <Route exact path={routes.ADMINEVENTS} component={() => <AdminEvents />} />
          <Route exact path={routes.ADMINEVENTDETAILS_WITH_CANIDATES} component={() => <AdminEventDetails />} />
          <Route exact path={routes.ADMINEVENTDETAILS_WITHOUT_CANIDATES} component={() => <AdminEventDetailsNoCanidate />} />
          <Route exact path={routes.ADMIN_CONNECTED_EVENTS} component={() => <AdminConnectedEvents />} />
          <Route exact path={routes.ADMIN_CONFIRMED_EVENTS} component={() => <AdminConfirmedEvents />} />
          <Route exact path={routes.ADMIN_USER_MGM} component={() => <UserManagement />} />
          <Route exact path={routes.ADMIN_UNLOCKED_USER} component={() => <UserUnlocked />} />
          <Route exact path={routes.ADMIN_USERS_ONLINE} component={() => <UsersOnline />} />
          <Route exact path={routes.ADMIN_ADD_EVENT} component={() => <AdminAddEvent />} />
          <Route exact path={routes.DATENSCHUTZ} component={() => <Datenschutz />} />
          <Route exact path={routes.TEST} component={() => <GetUnlockedUsersOnline />} />
        </div>
            <AppNotification/>
        
        
        <Footer />
    </div>
  </Router> 
  )
}

export default initializeApp()(App);


// WEBPACK FOOTER //
// ./src/Components/App/App.js